function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var MOBILE_HEADER_HEIGHT = 50;
export default (function (_ref) {
  var _content;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries,
    sizes = _ref.sizes;
  return {
    container: _defineProperty({
      position: 'relative',
      zIndex: 1000
    }, mediaQueries.breakpointTablet, {
      background: colors.white,
      boxShadow: '0 1px 2px rgba(0, 1, 1, 0.15)',
      width: '100%'
    }),
    filled: {
      background: colors.white,
      boxShadow: '0 1px 5px rgba(0, 1, 1, 0.15)'
    },
    headroom: {
      position: 'relative',
      zIndex: 5
    },
    headroom__fixed: _defineProperty({}, mediaQueries.breakpointTablet, {
      position: 'fixed',
      width: '100%'
    }),
    mobileTransparent: _defineProperty({}, mediaQueries.breakpointTablet, {
      background: 'none',
      boxShadow: 'none'
    }),
    links: _defineProperty({
      position: 'absolute',
      right: 0,
      bottom: 0
    }, mediaQueries.breakpointTablet, {
      display: 'none'
    }),
    mobileLinks: {
      background: colors.primary,
      position: 'fixed',
      zIndex: 5,
      top: "".concat(MOBILE_HEADER_HEIGHT, "px"),
      right: 0,
      bottom: 0,
      left: 0,
      display: 'none',
      overflow: 'auto',
      padding: '10px 25px 14px',
      '&.visible': _defineProperty({}, mediaQueries.breakpointTablet, {
        display: 'block'
      })
    },
    mobileLinksNoMargin: {
      margin: '0 !important'
    },
    content: (_content = {
      position: 'relative',
      width: sizes.container,
      margin: '0 auto',
      padding: '22px 0',
      height: '80px'
    }, _defineProperty(_content, mediaQueries.breakpointLaptop, {
      width: '100%'
    }), _defineProperty(_content, mediaQueries.breakpointTablet, {
      height: "".concat(MOBILE_HEADER_HEIGHT, "px"),
      padding: '10px'
    }), _defineProperty(_content, mediaQueries.laptop, {
      padding: '22px 15px'
    }), _defineProperty(_content, mediaQueries.laptopSmall, {
      padding: '22px 15px'
    }), _content),
    divided: {
      borderTop: "2px solid ".concat(colors.primaryLight)
    },
    '@global': {
      '.menuShown': _defineProperty({}, mediaQueries.breakpointTablet, {
        overflow: 'hidden'
      })
    }
  };
});